import { render, staticRenderFns } from "./main_new.vue?vue&type=template&id=7dd0f6f4&scoped=true"
import script from "./main_new.vue?vue&type=script&lang=js"
export * from "./main_new.vue?vue&type=script&lang=js"
import style0 from "./main_new.vue?vue&type=style&index=0&id=7dd0f6f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd0f6f4",
  null
  
)

export default component.exports